import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const Input = ({
	className,
	type,
	...props
}: React.ComponentProps<'input'>) => {
	return (
		<input
			data-slot="input"
			type={type}
			className={cn(
				//'h-16 w-full text-black dark:text-white rounded-lg border border-night-200 bg-white dark:border-night-400 dark:bg-night-700 px-4 pt-4 text-body-xs dark:caret-white outline-none focus:border-accent-purple disabled:bg-night-400',
				'border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring aria-[invalid]:border-input-invalid flex h-16 w-full rounded-lg border px-4 pt-4 text-body-xs dark:caret-white outline-none focus:border-accent-purple disabled:bg-night-400',
				className,
			)}
			{...props}
		/>
	)
}

export { Input }
